<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="editProductUrlModal" persistent max-width="540px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Edit ProductUrl</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeEditProductUrlModal()" class="close">X</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert :value="seccessAlert" type="success">
                ProductUrl updated successfully
              </v-alert>
              <v-alert type="error" :value="UrlError">
                URL format not acceptable
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm5 md5>
                    <v-text-field
                      label="Product Url"
                      v-model="editProductUrlData.product_url"
                      :error-messages="errors.collect('Product Url')"
                      v-validate="'required'"
                      data-vv-name="Product Url"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto; margin-right: 20px"
                outline
                color="success"
                >Save</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'seccessAlert',
    'editProductUrlModal',
    'closeEditProductUrlModal',
    'editProductUrlData',
    'editProductUrl',
    'UrlError'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editProductUrl()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editProductUrl.vue